import { render, staticRenderFns } from "./TextWithSidebar.vue?vue&type=template&id=02bb9222"
import script from "./TextWithSidebar.vue?vue&type=script&lang=js"
export * from "./TextWithSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports